export class Commonvariable {
  public currency="₹";
}
